import logo from './bt.jpg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} alt="logo" />
        <h1>Hi TOBY!</h1>
      </header>
    </div>
  );
}

export default App;
